import { RadioButton } from "@newsela/angelou";
import PropTypes from "prop-types";

import { choiceProptype } from "@/view/PollContainer/PollProptypes";
import {
  interactivePollOptionCss,
  interactivePollOptionTextCss,
} from "./InteractivePollOption.style";

const propTypes = {
  choice: choiceProptype,
  dataQaSelector: PropTypes.string,
  setSelectedValue: PropTypes.func,
};

const InteractivePollOption = ({
  choice,
  dataQaSelector,
  setSelectedValue,
}) => (
  <RadioButton
    __cssFor={{
      root: interactivePollOptionCss,
      labelText: interactivePollOptionTextCss,
    }}
    dataProps={{ "data-qa-selector": dataQaSelector }}
    label={choice.text}
    name="poll"
    onChange={() => setSelectedValue(choice.choice_id)}
  />
);

InteractivePollOption.propTypes = propTypes;

export default InteractivePollOption;
